function setDayIndex(date, dayIndex) {
    var diff = dayIndex - date.getDay();
    date.setDate(date.getDate() + diff);
}
export function renderDayName(locale, dayIndex) {
    var tempDate = new Date();
    setDayIndex(tempDate, dayIndex);
    return tempDate.toLocaleDateString(locale, { weekday: 'short' });
}
export function renderMonthAndYear(locale, baseDate) {
    var result = baseDate.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long'
    });
    return result;
}
/*
 `toLocaleDateString` is expensive (10+ ms) to calculate in IE11.
*/
var dayLabelCache = new Map();
export function renderDayLabel(locale, date) {
    var cacheKey = locale + date.getTime();
    var cachedValue = dayLabelCache.get(cacheKey);
    if (cachedValue) {
        return cachedValue;
    }
    var value = date.toLocaleDateString(locale, {
        weekday: 'long',
        month: 'short',
        day: 'numeric'
    });
    dayLabelCache.set(cacheKey, value);
    return value;
}
export function getDateLabel(locale, date) {
    return date
        ? date.toLocaleDateString(locale, {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        })
        : null;
}
//# sourceMappingURL=intl.js.map